import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { EmptyView, withTranslation } from '@piwikpro/ui-components';

const UserGroupsEmpty = withTranslation('administration')(({ t }: any) => (
  <EmptyView text={t('user-groups.list.emptyMessage')} />
));

export const Route = createFileRoute('/_secured/administration/user-groups/')({
  component: UserGroupsEmpty,
});
